"use client";
import { Video } from "../../media/video.js";
import { MinimalVideoSkin } from "./minimal-skin.js";
import { VideoPlayer, usePlayer } from "./player.js";
import { VideoSkin } from "./skin.js";
import { videoFeatures } from "@videojs/core/dom";
//#region src/presets/video/index.ts
/** General-purpose video player preset with full playback controls. */
//#endregion
export { MinimalVideoSkin, Video, VideoPlayer, VideoSkin, usePlayer, videoFeatures };

//# sourceMappingURL=index.js.map